module.exports = ".type{\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n    font-size: 1.1rem;\n    color: rgb(80,80,80);\n    margin: 0 auto;\n    width: 90%;\n  }\n  \n  .mandatory{\n    color: red;\n  }\n  \n  /* ion-range-slider .js-irs-2 .irs-bar{\n    background-color: yellow;\n    width:29%;\n  } */\n  \n  /*  \n  .container.color-yellow .irs-line {\n    background-color: yellow;\n} */"


//////////////////
// WEBPACK FOOTER
// ./src/app/questions-type/range-type/range-type.component.css
// module id = ./src/app/questions-type/range-type/range-type.component.css
// module chunks = main